import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";
import type { HistoryRujukanItem, HistorySepItem, HistorySrkItem, IfcPrepSep } from "@/types/bridging_bpjs";

interface Data<T> {
  data: T
}

async function getHistorySep(noka: string): Promise<Data<HistorySepItem[]>> {
  const response = await http.getData(`/peserta/${noka}/history/sep`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function getHistorySrk(noka: string): Promise<Data<HistorySrkItem[]>> {
  const response = await http.getData(`/peserta/${noka}/history/srk`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function getHistoryRujukan(noka: string): Promise<Data<HistoryRujukanItem[]>> {
  const response = await http.getData(`/peserta/${noka}/history/rujukan`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function getICareByReg(registerId: number, dokterId: string): Promise<{
  status: 1|0,
  data: any,
  message: string
}> {
  const response = await http.getData(`/icare/register/${registerId}/dokter/${dokterId}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

export default {
  getHistorySep,
  getHistorySrk,
  getHistoryRujukan,
  getICareByReg
}
